import React, { useState, useEffect } from "react";
import { ContainerContent, BoxCategories } from "./styles";
import Accordion from "@mui/material/Accordion";
import { Container } from "react-bootstrap";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { HiOutlineChevronDown } from "react-icons/hi";
import { getCategories, getFlattenedCategories } from "components/BurgerMenuContents/MenuContainer/Categories/services/categoriesServices";
import notify from "components/UI/toast";
import SearchInput from "components/SearchInput";
import Scroll from "components/ScrollToTop";
import Title from "components/Title";
import { useNavigate } from "react-router";
import { useOpen } from "hooks/Open";
import { trackClick } from "../../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../../hooks/useScreenTracking";

export default function Categories() {
  const { OpenButton, setCategory, forceCloseAllMenu } = useOpen();
  const navigate = useNavigate();
  const screenName = useScreenTracking();
  const TAG_ID = "03";
  const LIST_SCREEN_NAME = "lista-categorias";
  const CONTENT_TYPE = "lista-categorias";
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [expandedAccordions, setExpandedAccordions] = useState(new Set());

  function groupByKey(array, prop) {
    return array.reduce(function (items, item) {
      const key = item[prop];
      items[key] = (items[key] || []).concat(item);
      return items;
    }, {});
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getCategories();
        setData(getFlattenedCategories(response));

        const group = response.map((item) => ({
          category: item,
          subcategories: item.children || [],
        }));

        setCategories(group);

        setLoading(false);
      } catch (err) {
        setLoading(false);
        notify("Erro ao tentar carregar categorias", "error");
      }
    };

    fetchData();
  }, []);

  const filter = () => {
    const searchInput = search.toLowerCase();

    const subCategoriesFilter = data.filter((sub) => sub.parent_uuid);
    const categoriesFilter = data.filter((category) => !category.parent_uuid);

    const filterSub = subCategoriesFilter.filter((item) =>
      item.label.toLowerCase().startsWith(searchInput.toLowerCase())
    );

    const filterCat = categoriesFilter.filter((item) =>
      item.label.toLowerCase().startsWith(searchInput.toLowerCase())
    );

    const filterGroupSubKey = groupByKey(filterSub, "parent_uuid");

    const getCategory = (param) => {
      const item = categoriesFilter.filter((i) => i.uuid === param);
      return item[0];
    };

    const cat = filterCat.map((item) => ({
      category: item,
      subcategories: [],
    }));

    let sub = filterSub.map((item) => ({
      category: getCategory(item.parent_uuid),
      subcategories: filterGroupSubKey[item.parent_uuid]
        ? filterGroupSubKey[item.parent_uuid]
        : [],
    }));

    sub = sub.filter((item) => item.category);

    return cat.concat(sub);
  };

  const redirectPage = (id, categoryLabel) => {
    trackClick({
      title: categoryLabel ? categoryLabel.toLowerCase().replace(/\s/g, '-') : 'categoria',
      contentType: CONTENT_TYPE,
      screenName: LIST_SCREEN_NAME,
      tagId: tagIdFromLegacySuffix(TAG_ID),
    });
    
    forceCloseAllMenu();
    navigate(`/loja/category/${id}`);
  };

  const handleAccordionChange = (categoryUuid, categoryLabel) => (event, isExpanded) => {
    if (isExpanded) {
      setExpandedAccordions(prev => new Set(prev).add(categoryUuid));
      trackClick({
        title: `abriu-${categoryLabel.toLowerCase().replace(/\s/g, '-')}`,
        contentType: CONTENT_TYPE,
        screenName: LIST_SCREEN_NAME,
        tagId: tagIdFromLegacySuffix(TAG_ID),
      });
    } else {
      setExpandedAccordions(prev => {
        const newSet = new Set(prev);
        newSet.delete(categoryUuid);
        return newSet;
      });

      trackClick({
        title: `fechou-${categoryLabel.toLowerCase().replace(/\s/g, '-')}`,
        contentType: CONTENT_TYPE,
        screenName: LIST_SCREEN_NAME,
        tagId: tagIdFromLegacySuffix(TAG_ID),
      });
    }
  };

  const hasLink = (cat) =>
    Array.isArray(cat?.categories_uuid) && cat.categories_uuid.length > 0;

  const filterCategories = search && search.length >= 2 ? filter() : categories;

  return (
    <div className="wl-page mt-4">
      <Container>
        <Title
          titleClass="text-left width-100 py-3"
          label="Categorias"
        ></Title>
        <SearchInput
          value={search}
          onChange={(e) => setSearch(e)}
          placeholder="Procurar categoria"
        />

        {loading ? (
          <div className="text-center">
            <p className="fs-6">Carregando categorias </p>
          </div>
        ) : !filterCategories.length ? (
          <div className="text-center">
            <p className="fs-6">Nenhuma categoria encontrada </p>
          </div>
        ) : (
          <BoxCategories className="mt-3">
            <ContainerContent component="ul">
              {filterCategories.map((item, index) => {
                return item.subcategories.length > 0 ? (
                  <React.Fragment key={item.category.uuid}>
                    <div key={index}>
                      <Accordion 
                        sx={{ boxShadow: 0 }} 
                        className="accordion"
                        onChange={handleAccordionChange(item.category.uuid, item.category.label)}
                      >
                        <AccordionSummary
                          expandIcon={<HiOutlineChevronDown size={20} />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className="p-0"
                        >
                          <span
                            style={{ color: '#00003C' }}
                            className="text-mg font-wl-500 color-text-dark"
                            onClick={hasLink(item.category) ? () => redirectPage(item.category.uuid, item.category.label) : undefined}
                            role={hasLink(item.category) ? 'button' : undefined}
                          >
                            {item.category.label}
                          </span>
                        </AccordionSummary>
                        <AccordionDetails
                          key={item.category.uuid}
                          className="pt-0 subcategories"
                          style={{ marginLeft: '10px', marginTop: '12px'}}
                        >
                          {item.subcategories.map((subcategorie, index) => (
                            <li
                              key={index}
                              className="text-mg font-wl-500 color-wl-light"
                            >
                              <span
                                className="text-sm font-wl-600"
                                onClick={hasLink(subcategorie) ? () => redirectPage(subcategorie.uuid, subcategorie.label) : undefined}
                                role={hasLink(subcategorie) ? 'button' : undefined}
                                style={{ cursor: hasLink(subcategorie) ? 'pointer' : 'default' }}
                              >
                                {subcategorie.label}
                              </span>
                            </li>
                          ))}
                        </AccordionDetails>
                      </Accordion>
                    </div>
                    <hr className="m-0" />
                  </React.Fragment>
                ) : (
                  <>
                    <li
                      key={`${item.category.uuid}-${index}`}
                      className="list-content"
                    >
                      <span
                        className="text-mg font-wl-500 color-text-dark"
                        onClick={hasLink(item.category) ? () => redirectPage(item.category.uuid, item.category.label) : undefined}
                        role={hasLink(item.category) ? 'button' : undefined}
                        style={{ cursor: hasLink(item.category) ? 'pointer' : 'default' }}
                      >
                        {item.category.label}
                      </span>
                    </li>
                    <hr className="m-0" />
                  </>
                );
              })}
            </ContainerContent>
          </BoxCategories>
        )}
      </Container>
      <Scroll />
    </div>
  );
}
